import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { wgApi } from '../../../app/src/features/api/wgApi';

interface SelfProps {
  self: string;
  module: string;
  refetchOnWindowFocus?: boolean;
}

export const getSelf = async <T>(self: string) => {
  const { data, isError } = await wgApi.get<T>(self);
  if (isError) throw new Error(JSON.stringify(data));
  return data;
};

export const getSelfQkey = ({ module, self }: SelfProps): string[] => [
  'self',
  module,
  self,
];

export const useSelf = <T>(
  props: SelfProps,
  options?: Omit<
    UseQueryOptions<unknown, unknown, T, string[]>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<T> => {
  return useQuery(getSelfQkey(props), () => getSelf(props.self), {
    refetchOnWindowFocus: false,
    ...options,
  });
};
